interface GithubProject {
  id: string;
  title: string;
  description: string;
  githubUrl: string;
  demoUrl?: string;
  image: string;
  technologies: string[];
}

const githubProjects: GithubProject[] = [
  {
    id: 'sage-squads',
    title: 'SageSquads',
    description:
      'A SaaS product for running live player drafts for youth sports leagues—scheduling, picks, and league workflows in one place. Built and shipped over the past year.',
    githubUrl: 'https://github.com/barbourshop/sage-squads',
    demoUrl: 'https://sagesquads.com/',
    image: '/images/sage-squads-logo-no-alpha.png',
    technologies: ['React', 'TypeScript', 'Node.js', 'Vite', 'AWS']
  },
  {
    id: 'guest-self-checkin',
    title: 'Rec Center Guest Self Check-In App',
    description: 'A web app which allows guests to self-check in when they arrive at the rec center.  Application is deployed at the Big Trees Village Rec Center in Arnold, CA, and makes use of the Square API to check for membership and to allow guests to sign a waiver.',
    githubUrl: 'https://github.com/barbourshop/guest-self-checkin',
    demoUrl: 'https://btv-self-checkin-demo.matt-barbour.com/',
    image: '/images/btv-self-checkin.jpeg',
    technologies: ['React', 'TypeScript', 'Node.js', 'Vite', 'Playwright', 'Jest']
  },
  {
    id: 'sudoku-app',
    title: 'Sudoku App',
    description: 'A sudoku game built entirely with AI in react, node.js, & typescript.  Developed as part of an exploration into the capabilities of AI in building complex applications.',
    githubUrl: 'https://github.com/barbourshop/sudoku-bolt',
    demoUrl: 'https://sudoku.matt-barbour.com/',
    image: '/images/sudoku-game.png',
    technologies: ['React', 'TypeScript', 'Bolt.new', 'Vite']
  },
  {
    id: 'shout-out',
    title: 'Shout Out Game',
    description: 'A simple word guessing game app which mimics parts of the popular game Scattergories.  Built in react, node.js, & typescript using Cursor AI.',
    githubUrl: 'https://github.com/barbourshop/roadtrip-word-app',
    demoUrl: 'https://shoutout.matt-barbour.com/',
    image: '/images/shoutout-app.jpg',
    technologies: ['React', 'TypeScript', 'Vite', 'Cursor AI']
  }
];

export type { GithubProject };
export { githubProjects }; 